import { useCallback } from "react";
import { dialogService } from "services";

interface DialogOptions {
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export const useDialog = () => ({
  confirm: useCallback(
    (options: DialogOptions) => dialogService.confirm(options),
    [],
  ),
});